import {BaseApi} from "@/core/api/base.api";
import {Room} from "@/core/api/room.api";
import {RoomCamStudy} from "@/core/api/camstudy/room.camstudy.api";
import GrmSelfieSegmentationFactory from "@/lib/gooroomee/mediapipe/selfie-segmentation/grm-selfieSegmentation-factory";
import moment from "moment";

class RoomUserVacancyApi extends BaseApi {
    selfie;
    vacancyConfig = {
        useDetectVacancy: false,
        detectLimitMs: 60 * 1000,
    };

    constructor() {
        super();
        Room.User.Vacancy = this;

        Room.addEventListeners(this._CoreEvents, this);
        Room.ready(async e => {
            const {room, roomInfo} = Room.getRoomData();
            if(room.roomType !== 'cam_study'){
                return;
            }

            this._eventListen(this.#Events);
            Room.addRoomData({roomCamStudy: {}});
        }, {order: 100});
    }

    async initVacancyConfig(){
        const camStudy = Room.getRoomData().roomCamStudy?.camStudy;
        const detectVacancySeconds = camStudy?.vacancyDetectMinutes * 60

        this.vacancyConfig.useDetectVacancy = camStudy?.useVacancyDetection;
        this.vacancyConfig.detectLimitMs = Math.max(
            (detectVacancySeconds || 0) * 1000,
            60 * 1000
        )
    };

    async getSelfieSegmentation () {
        if(this.selfie) return this.selfie;
        this.selfie = GrmSelfieSegmentationFactory.create({
            selfieSegmentation: {
            }
        });
        await this.selfie.init();
        return new Promise((resolve, reject) => {
            setTimeout(() => {
                resolve(this.selfie);
            }, 500);
        });
    }

    async stopVacancyMonitor (){
        if(!this.selfie) return;
        const result = this.selfie._result;
        if(!result) return;
        try{
            result.destroy();
            delete this.selfie._result;
        }catch(e){}
    }

    async startVacancyMonitor (){
        await this.initVacancyConfig();

        const canMonitor = () => {
            if(!this.vacancyConfig.useDetectVacancy) return false;
            const me = Room.User.getMe();
            const isStopWatchStart = Room.CamStudy.isStopwatchStartState(me.userId);
            if(me.roomUserRole.camera !== true || me.cameraStatus !== 'on' || !isStopWatchStart){
                return false;
            }
            return true;
        };

        if(!canMonitor()){
            return;
        }

        const stream = Room.Call.getUserVideoStream(Room.User.getMe());
        if(!stream || stream.getVideoTracks().length === 0) return;

        const app = await this.getSelfieSegmentation();
        if(app._result && !app._result.isDestroyed()){
            app._result.resume();
            return;
        }

        // start
        app._detectData = {
            lastDetectedTime: Date.now(),
            detected: true,
            sent: {
                seat: true, left: false
            }
        };
        const callback = result => {
            app._result = result;
            if(!canMonitor()){
                result.destroy();
                return;
            }

            const {hasPerson} = result.data
            // const rate = result.data.parseData?.rate;

            const dData = app._detectData;

            // 감지됨
            if(hasPerson){
                // console.log('@@@@@@@ 자리 감지됨 [%s]', moment(new Date()).format('YYYY-MM-DD HH:mm:ss'));
                if(!dData.detected){
                    const timeMs = Date.now() - dData.lastDetectedTime;
                    if(!dData.sent.seat){
                        dData.sent.seat = true;
                        dData.sent.left = false;
                        // 자리 앉음 알림 : seat
                        // console.log('@@@@@@@ 자리 앉음')
                        RoomCamStudy.changeStudyStatus(Room.User.getMe().userId, {
                            studyStatus: 'STUDY',
                            timeMs: timeMs
                        })

                        result.changeDetectIntervalMs(
                            Math.max(this.vacancyConfig.detectLimitMs / 2, 60 * 1000)
                        )
                    }
                }

                dData.detected = true;
                dData.lastDetectedTime = Date.now();
                return;
            }

            // 감지 안됨
            dData.detected = false;
            // 감지 주기 짧게 변경
            result.changeDetectIntervalMs(
                Math.max(this.vacancyConfig.detectLimitMs / 6, 5 * 1000)
            );
            let timeMs = Date.now() - dData.lastDetectedTime;
            // console.log('@@@@@@@ 자리 비움: %s초', parseInt(timeMs/1000))
            if(timeMs < this.vacancyConfig.detectLimitMs){
                return;
            }
            // 제한 시간 지남
            if(!dData.sent.left){
                dData.sent.seat = false;
                dData.sent.left = true;
                // console.log('@@@@@@@ 자리 비움 전송')
                RoomCamStudy.changeStudyStatus(Room.User.getMe().userId, {
                    studyStatus: 'VACANCY',
                    timeMs: timeMs
                })

                const image = result.data.results.image
                Room.trigger('room_vacancyDetectImageUpload',
                    {
                        file: image,
                        type: 'VACANCY_DETECT',
                    },
                );
            }
        }

        // console.log('# 자리 비움 감지 시작')
        app.segmentMonitorForStream({
            stream,
            detectIntervalMs: this.vacancyConfig.detectLimitMs / 2,
            callback
        });
    }

    updateVacancyDetectTime (updatedDetectLimitMs) {
        this.vacancyConfig.detectLimitMs = Math.max(
            (updatedDetectLimitMs || 0),
            60 * 1000
        );

        const result = this.selfie?._result;

        if (result && !result.isDestroyed()) {
            const isDetected = this.selfie?._detectData.detected;
            const intervalMs = isDetected
                ? this.vacancyConfig.detectLimitMs / 2
                : Math.max(this.vacancyConfig.detectLimitMs / 6, 5 * 1000);

            result.changeDetectIntervalMs(intervalMs);
        }
    }

    _CoreEvents = {
        room_call_loadLocalStream: async function(e) {
            this.startVacancyMonitor();
        },
        room_data_init: async function(e) {
            this.startVacancyMonitor();
        },
        room_changeUserDeviceStatus: async function(e) {
            this.startVacancyMonitor();
        },
        room_changeUserRole: async function(e) {
            this.startVacancyMonitor();
        },
        room_cstudy_changeUseVacancy: async function(e) {
            e.data?.useVacancyDetection ? this.startVacancyMonitor() : this.stopVacancyMonitor();
        },
        room_cstudy_changeVacancyDetectMinutes: async(e) => {
            const updatedDetectLimitMs = e.data.vacancyDetectMinutes * 60 * 1000;
            this.updateVacancyDetectTime(updatedDetectLimitMs);
        },
        room_cstudy_changeStopwatchState: async(e) => {
            e.data.stopwatch.state !== 'start' ? this.stopVacancyMonitor() : this.startVacancyMonitor();
        },
    }
    #Events = {
    }
}

export const RoomUserVacancy = new RoomUserVacancyApi();